import React, { useState } from 'react';
import { tracksAPI } from '../../services/api';
import './Admin.css';

const UploadTrack = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [uploadForm, setUploadForm] = useState({
    title: '',
    lyrics: '',
  });

  const handleUpload = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const fileInput = document.getElementById('audioFile');
    const file = fileInput.files[0];

    if (!file) {
      setError('Selecteer een audio bestand');
      return;
    }

    // Validatie
    if (!uploadForm.title.trim()) {
      setError('Titel is verplicht');
      return;
    }

    if (!uploadForm.lyrics.trim()) {
      setError('Lyrics zijn verplicht');
      return;
    }

    const formData = new FormData();
    formData.append('audio', file);
    
    if (uploadForm.title) formData.append('title', uploadForm.title);
    if (uploadForm.lyrics) formData.append('lyrics', uploadForm.lyrics);

    try {
      setUploading(true);
      await tracksAPI.upload(formData);
      setSuccess('Track uploaded successfully!');
      setUploadForm({ title: '', lyrics: '' });
      fileInput.value = '';
    } catch (error) {
      setError(error.response?.data?.error || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-track">
      <header className="page-header">
        <h1>Upload Track</h1>
        <p>Voeg nieuwe muziek toe aan je radio</p>
      </header>

      {error && <div className="message error"><i className="fas fa-exclamation-circle"></i> {error}</div>}
      {success && <div className="message success"><i className="fas fa-check-circle"></i> {success}</div>}

      <div className="upload-card">
        <form onSubmit={handleUpload} className="upload-form">
          <div className="form-group">
            <label htmlFor="audioFile">
              <i className="fas fa-file-audio"></i> Audio Bestand *
            </label>
            <div className="file-input-wrapper">
              <input
                type="file"
                id="audioFile"
                accept="audio/*"
                required
                disabled={uploading}
              />
              <p className="help-text">Maximum bestandsgrootte: 100MB</p>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="title">
              <i className="fas fa-heading"></i> Titel *
            </label>
            <input
              type="text"
              id="title"
              placeholder="Voer de titel in"
              value={uploadForm.title}
              onChange={(e) => setUploadForm({ ...uploadForm, title: e.target.value })}
              disabled={uploading}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="lyrics">
              <i className="fas fa-align-left"></i> Lyrics *
            </label>
            <textarea
              id="lyrics"
              placeholder="Voer de lyrics in"
              value={uploadForm.lyrics}
              onChange={(e) => setUploadForm({ ...uploadForm, lyrics: e.target.value })}
              rows="10"
              disabled={uploading}
              required
            />
            <p className="help-text">Lyrics zijn verplicht voor alle tracks</p>
          </div>

          <button type="submit" className="btn-primary btn-large" disabled={uploading}>
            {uploading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Uploading...
              </>
            ) : (
              <>
                <i className="fas fa-upload"></i> Upload Track
              </>
            )}
          </button>
        </form>

        <div className="upload-info">
          <h3><i className="fas fa-info-circle"></i> Upload Informatie</h3>
          <ul>
            <li>Ondersteunde formaten: MP3, WAV, FLAC, OGG</li>
            <li>Maximum bestandsgrootte: 100MB</li>
            <li>Titel en lyrics zijn verplicht</li>
            <li>Album art wordt automatisch geëxtraheerd uit MP3 metadata</li>
            <li>Track wordt automatisch toegevoegd aan de radio playlist</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UploadTrack;
